// ABOUTME: Staff remove one member from a client company, after confirming who is removed.
// ABOUTME: The backend soft deletes the member's login unless they are also a candidate or staff.
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '$components/Buttons/Button';
import ModalInTailwind from '$components/ModalInTailwind/ModalInTailwind';
import { useRemoveCompanyMemberMutation } from '$store/modules/companies';

type RemoveMemberProps = {
  companyId: number;
  employerId: number;
  // Who is removed, as staff should recognize them: name and email.
  label: string;
};

const RemoveMember = ({ companyId, employerId, label }: RemoveMemberProps) => {
  const [t, i18next] = useTranslation('global');
  const [isOpen, setIsOpen] = useState(false);
  const [removeMember, { isLoading }] = useRemoveCompanyMemberMutation();

  const closeModal = () => setIsOpen(false);

  const remove = async () => {
    const response = await removeMember({
      companyId,
      employerId,
      lang: i18next.language as 'en' | 'es',
    });
    if (!('error' in response)) closeModal();
  };

  return (
    <>
      <Button
        text={t('CompaniesTable.Remove')}
        showText
        textStyles={{ color: '#c0392b' }}
        onClick={() => setIsOpen(true)}
      />
      <ModalInTailwind isOpen={isOpen} closeModal={closeModal}>
        <div className="bg-white rounded p-8 flex flex-col">
          <h2 className="font-bold text-xl mb-4">
            {t('CompaniesTable.RemoveMemberConfirm', { member: label })}
          </h2>
          <div className="flex flex-row mt-4 self-end w-60">
            <Button
              text={t('common.cancel')}
              showText
              textStyles={{ color: '#079e88' }}
              onClick={closeModal}
            />
            <Button
              text={t('CompaniesTable.Remove')}
              showText
              disabled={isLoading}
              bgColor={isLoading ? '#aaa' : '#c0392b'}
              textStyles={{ color: 'white' }}
              onClick={remove}
              data-testid="confirm-remove-member"
            />
          </div>
        </div>
      </ModalInTailwind>
    </>
  );
};

export default RemoveMember;
